import { gql } from 'graphql-request';

const couriersEstimationsQuery = gql`
  query($number: String!) {
    getCouriersEstimations(number: $number)
  }
`;

export default couriersEstimationsQuery;
